import type { PartnerBadge } from "@shopexperts/shared";

export const STORE_LISTING_URL_PATTERN = /^(https?:\/\/)?(apps\.shopify\.com\/[a-z0-9][a-z0-9_-]*\/?|themes\.shopify\.com\/themes\/[a-z0-9][a-z0-9_-]*(\/[^\s?#]*)?)([?#]\S*)?$/i;

export function listingStoreLabel(badge: Pick<PartnerBadge, "listing_type">): string {
  return badge.listing_type === "theme" ? "Theme Store" : "App Store";
}

export function listingStatusChip(badge: PartnerBadge): { text: string; variant: "success" | "warn" | "neutral" | "default"; tooltip?: string } | null {
  if (!badge.listing_url) return null;
  const store = listingStoreLabel(badge);
  const sync = badge.listing_sync;

  switch (sync?.status) {
    case "synced":
      return { text: `${store} · Synced`, variant: "success", tooltip: sync.last_synced_at ? `Last synced ${formatDateTime(sync.last_synced_at)}` : undefined };
    case "failed":
      return { text: `${store} · Sync failed`, variant: "warn", tooltip: sync.error?.message };
    default:
      return { text: `${store} · Pending`, variant: "neutral", tooltip: "Waiting for the first sync" };
  }
}

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString("en-US", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
}
